import moment from 'moment';
import 'daterangepicker';
import daterangePickerPtBr from '../../entrypoints/src/admin/i18n/daterange-picker.pt-br';
import AjaxLoader from '../../entrypoints/src/admin/utilities/ajax-loader';

import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
		this.dateRangePicker();
  }

	dateRangePicker() {
    let _this = this.element,
      picker = $(this.element),
      startDate = moment(picker.data('startDate')),
      endDate = moment(picker.data('endDate'));

    picker.daterangepicker({
        locale: daterangePickerPtBr,
        startDate: startDate,
        endDate: endDate,
        opens: 'left',
        applyButtonClasses: 'btn btn-sm btn-secondary',
        ranges: {
          'Mês Retrasado': [moment().subtract(2, 'month').startOf('month'), moment().subtract(2, 'month').endOf('month')],
          'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Esse Mês': [moment().startOf('month'), moment().endOf('month')],
          'Próximo Mês': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
        }
    }, (start, end) => {
      AjaxLoader.show();
      document.querySelector(_this.dataset.startDateInput).value = start.format('DD/MM/YYYY');
      document.querySelector(_this.dataset.endDateInput).value = end.format('DD/MM/YYYY');
      document.querySelector(_this.dataset.formTarget).submit();
    });

    this.initDateRangePicker(picker, startDate, endDate, 'Personalizado');
	}

	initDateRangePicker(picker, start, end, label) {
		let title = '', range = '';

		if (label == 'Personalizado') {
			range = start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY');
		} else {
			title = !!label ? label : 'Esse Mês';
			range = start.format('MMMM [de] YYYY');
		}

		picker.html(range);
	}
}